/* eslint-disable */
import { useEffect } from 'react'
import { routeArr } from './routes'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from './components/layouts/navbar'
import Footer from './components/layouts/footer'
import MobileBottomBar from './components/layouts/MobileBottomBar'
import Error from './pages/error'
import PageContextProvider from './context/PageContextProvider'

const CursorSpotlight = () => {
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const el = document.getElementById('bpg-cursor-spotlight');
    if (!el) return;
    let rafId;
    const onMove = (e) => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        el.style.transform = `translate3d(${e.clientX - 250}px, ${e.clientY - 250}px, 0)`;
        el.style.opacity = '1';
      });
    };
    const onLeave = () => {
      if (el) el.style.opacity = '0';
    };
    window.addEventListener('mousemove', onMove, { passive: true });
    document.addEventListener('mouseleave', onLeave);
    return () => {
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseleave', onLeave);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      id="bpg-cursor-spotlight"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        pointerEvents: 'none',
        zIndex: 1,
        opacity: 0,
        transition: 'opacity 0.3s ease',
        background: 'radial-gradient(circle, rgba(65, 109, 180, 0.12) 0%, rgba(225, 188, 36, 0.04) 45%, transparent 70%)',
        willChange: 'transform',
      }}
    />
  );
};

const App = () => {
  return (
    <PageContextProvider>
      <CursorSpotlight />
      <BrowserRouter>
        <Routes>
          {routeArr.map((item) => (
            <Route
              exact
              path={item.path}
              key={item.id}
              element={
                <>
                  <Navbar title={item.title} />
                  <main className="page">
                    <item.component />
                  </main>
                  <Footer />
                  <MobileBottomBar />
                </>
              }
            />
          ))}
          <Route
            path="*"
            element={
              <>
                <Navbar title={'Error page'} />
                <main className="page">
                  <Error />
                </main>
                <Footer />
                <MobileBottomBar />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </PageContextProvider>
  )
}

export default App
